import { useMemo } from 'react';
import { createTheme, responsiveFontSizes } from '@mui/material/styles';

import PrefersDarkMode from '../lib/prefersDarkMode';

import RaleyWayVariable from './fonts/Raleway/Raleway-VariableFont_wght.ttf';
import RaleWayItalic from './fonts/Raleway/Raleway-Italic-VariableFont_wght.ttf';

const useTheme = () => {
  const prefersDarkMode = PrefersDarkMode();

  const paletteDark = {
    mode: 'dark',
    primary: {
      main: '#fff',
      light: '#CCC',
      dark: '#fff',
    },
    background: {
      paper: '#222',
    },
    filter: {
      image: 'brightness(0.4)',
    },
  };
  const paletteLight = {
    mode: 'light',
    primary: {
      main: '#000',
      light: '#CCC',
      dark: '#000',
    },
    background: {
      paper: '#eee',
    },
    filter: {
      image: 'none',
    },
  };

  return useMemo(
    () =>
      responsiveFontSizes(
        createTheme({
          palette: prefersDarkMode ? paletteDark : paletteLight,
          breakpoints: {
            values: {
              xs: 0,
              sm: 600,
              md: 900,
              lg: 1100,
              xl: 1536,
            },
          },
          typography: {
            fontFamily: ['Raleway', 'sans-serif'].join(','),
            h1: {
              fontSize: '3.5rem',
            },
            h2: {
              fontSize: '2.5rem',
            },
            ButtonNavigationTop: {
              fontSize: '0.7rem',
              textTransform: 'uppercase',
              color: 'text.secondary',
            },
          },
          components: {
            MuiCssBaseline: {
              styleOverrides: `
                @font-face {
                  font-family: 'Raleway';
                  src: local('format'), url(${RaleyWayVariable}) format('truetype');
                }

                @font-face {
                  font-family: 'Raleway-Italic';
                  src: local('format'), url(${RaleWayItalic}) format('truetype');
                }
              `,
            },
          },
        }),
      ),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [prefersDarkMode],
  );
};

export default useTheme;
